import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageMeta = {
  '/': {
    title: 'Keystone Strategic Consultants | Where Complex Projects Find Clarity',
    description: 'Hands-on consultancy and the Videra platform for organisations managing complex project portfolios. PFI, healthcare, and infrastructure specialists.'
  },
  '/about': {
    title: 'About Us | Keystone Strategic Consultants',
    description: 'Strategic consultancy and portfolio management software for complex project environments. We embed, not advise from the sidelines.'
  },
  '/services': {
    title: 'Services | Keystone Strategic Consultants',
    description: 'PFI & Lifecycle Advisory, Delivery Transformation, Governance & Assurance, and Videra Implementation services for complex project portfolios.'
  },
  '/videra': {
    title: 'Videra Platform | Portfolio Management Software | Keystone Strategic',
    description: 'Purpose-built portfolio management software for PFI, healthcare, and facilities management. Real-time visibility, automated governance, stakeholder portals.'
  },
  '/contact': {
    title: 'Contact Us | Keystone Strategic Consultants',
    description: 'Get in touch to discuss your project portfolio challenges. Book a discovery call or request a Videra platform demo.'
  }
};

export const SEOHead = () => {
  const location = useLocation();
  
  useEffect(() => {
    const meta = pageMeta[location.pathname] || pageMeta['/'];
    
    // Update title
    document.title = meta.title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', meta.description);
    }
    
    // Update OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', meta.title);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', meta.description);
    }
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', meta.title);
    }
    
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', meta.description);
    }
    
    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://keystoneconsulting.uk${location.pathname}`);
    }
    
  }, [location.pathname]);
  
  return null;
};

export default SEOHead;
